import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { If } from 'react-if';
import { createUseStyles } from 'react-jss';
import Anchor from '../Anchor';
import routes from '../../routes';
import bulmaStyle from '../../variables.scss';
import { useConfig } from '../../hooks/Configurator';
import Track from '../Track';
import { storeLocale } from '../../store/actions/i18n';
import Text from '../../i18n/Text';

const useStyle = createUseStyles({
  img: {
    height: bulmaStyle.navbarHeight,
  },
  navbar: {
    composes: ['navbar', 'is-fixed-top', 'is-transparent'],
    borderColor: bulmaStyle.background,
    borderWidth: 2,
    borderStyle: 'solid',
    maxHeight: `${bulmaStyle.navbarHeight} !important`,
    height: `${bulmaStyle.navbarHeight} !important`,
  },
});

const Navbar = () => {
  const logo = useConfig(({ bbGeneralOptions }) => bbGeneralOptions.logo);
  const currentPage = useSelector(({ page }) => page);
  const locales = useSelector((state) => state.i18n.locales);
  const currentLocale = useSelector((state) => state.i18n.locale);
  const dispatch = useDispatch();

  const { img, navbar } = useStyle();

  const analyticsLabel = currentPage.name === 'Item' ? currentPage.extra.params.title : null;

  function handleLocaleSelection(event) {
    const { value } = event.target;
    dispatch(storeLocale(value));
  }

  return (
    <nav className={navbar} role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <div className="navbar-item">
          <img src={logo} alt="Brand" className={img} />
        </div>
      </div>

      <div className="navbar-end">
        <div className="navbar-item">
          <If condition={currentPage.name !== 'Splash' && currentPage.name !== 'LocaleSelector'}>
            <Anchor
              to={routes.Splash}
              className="button is-outlined is-primary"
              qa-id="home-button"
            >
              <Track
                name="navbar.clickHome"
                bbTrackCategoryInfo={currentPage.name}
                bbTrackLabelInfo={analyticsLabel}
              >
                <i className="fa fa-home" />
                <span className="is-spaced" style={{ marginLeft: '.5rem' }}>
                  <Text>NAVBAR.HOME</Text>
                </span>
              </Track>
            </Anchor>
          </If>
        </div>
        <div className="navbar-item">
          <If condition={!!locales && locales.length > 1 && currentPage.name !== 'LocaleSelector'}>
            <div className="control has-icons-left">
              <div className="select">
                <select defaultValue={currentLocale} onChange={handleLocaleSelection}>
                  {
                    locales && locales.map((locale) => (
                      <option key={locale.code} value={locale.code}>{locale.name}</option>
                    ))
                  }
                </select>
                <span className="icon is-small is-left">
                  <i className="fas fa-globe" />
                </span>
              </div>
            </div>
          </If>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
